<template>
  <div class="main">
    <div class="columns is-mobile">
      <div class="column">
        <div class="button" @click="toMenu">メニュー管理</div>
      </div>
      <div class="column">
        <div class="button" @click="toSales">売上管理</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalMenu",
  data() {
    return {};
  },
  methods: {
    toMenu() {
      const teamId = this.$store.state.teamId;
      this.$router.push("/" + teamId + "/menus");
    },
    toSales() {
      const teamId = this.$store.state.teamId;
      this.$router.push("/" + teamId + "/sales");
    }
  },
  computed: {},
  mounted() {}
};
</script>

<style scoped>
.main {
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px;
}
</style>
